import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="section-title">About Tech Update</h2>
          <p className="section-subtitle">Your Trusted Technology Partner</p>
          <p className="section-description">
            We specialize in transforming ideas into powerful digital products that drive growth and success.
          </p>
        </div>

        <div className="aboutContent">
          <div className="about-text">
            <div className="about-description">
              <p>
                Tech Update is a dynamic startup founded with a mission to empower businesses through innovative 
                technology solutions. We specialize in transforming ideas into powerful digital products that drive 
                growth and success.
              </p>
              <p>
                Our team of experienced developers, designers, and strategists work together to deliver solutions 
                that are not just functional, but also beautiful, scalable, and user-friendly. We believe in 
                building long-term partnerships with our clients, understanding their unique needs, and providing 
                tailored solutions that exceed expectations.
              </p>
              <p>
                Whether you're a startup looking to launch your first app, or an established business seeking to 
                modernize your digital presence, we're here to help you succeed in the digital landscape.
              </p>
            </div>
            <div className="about-features">
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <div className="feature-content">
                  <h4>Fast Delivery</h4>
                  <p>We deliver projects on time without compromising quality</p>
                </div>
              </div>
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="feature-content">
                  <h4>Expert Team</h4>
                  <p>Skilled professionals with years of industry experience</p>
                </div>
              </div>
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <div className="feature-content">
                  <h4>Secure & Reliable</h4>
                  <p>Your data and applications are built with security in mind</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="about-graphic">
              <div className="tech-stack">
                <div className="tech-item">
                  <i className="fab fa-react"></i>
                  <span>React</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-android"></i>
                  <span>Android</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-apple"></i>
                  <span>iOS</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-node-js"></i>
                  <span>Node.js</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-wordpress"></i>
                  <span>WordPress</span>
                </div>
                <div className="tech-item">
                  <i className="fas fa-robot"></i>
                  <span>AI/ML</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
